import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Dialog, DialogButtonConfig, SharedModule } from '@vendure/admin-ui/core';

@Component({
  selector: 'vdr-html-dialog',
  template:  `
    <ng-template vdrDialogTitle>
        {{ title | translate:translationVars }}
    </ng-template>

    <div class="modal-body" [innerHTML]="safeBody"></div>

    <ng-template vdrDialogButtons>
        <ng-container *ngFor="let btn of buttons">
            <button
                class="button ml-2"
                [class.primary]="btn.type === 'primary'"
                [class.danger]="btn.type === 'danger'"
                (click)="resolveWith(btn.returnValue)"
            >
            {{ btn.label | translate:(btn.translationVars || {}) }}
            </button>
        </ng-container>
    </ng-template>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export class HtmlDialogComponent implements Dialog<any>, OnInit {
  resolveWith: (result?: any) => void;
  title = '';
  body = '';
  safeBody!: SafeHtml;
  buttons: DialogButtonConfig<any>[] = [];
  translationVars = {};

  constructor(
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.safeBody = this.sanitizer.bypassSecurityTrustHtml(this.body);
  }
}
